// Display texts derived from the backend FrequencyEnum (bound by member name).

export const FREQUENCY_SUFFIX = {
  OneTime:       '',
  Monthly:       ' por mês',
  Bimonthly:     ' por bimestre',
  Quarterly:     ' por trimestre',
  Quadrimonthly: ' por quadrimestre',
  Semesterly:    ' por semestre',
  Yearly:        ' por ano'
};

export const FREQUENCY_ADJECTIVE = {
  OneTime:       'única',
  Monthly:       'mensal',
  Bimonthly:     'bimestral',
  Quarterly:     'trimestral',
  Quadrimonthly: 'quadrimestral',
  Semesterly:    'semestral',
  Yearly:        'anual'
};
